import { render, staticRenderFns } from "./Volleyball.vue?vue&type=template&id=53f03dba&scoped=true"
import script from "./Volleyball.vue?vue&type=script&lang=js"
export * from "./Volleyball.vue?vue&type=script&lang=js"
import style0 from "./Volleyball.vue?vue&type=style&index=0&id=53f03dba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f03dba",
  null
  
)

export default component.exports